import { DataTable, DataTableData } from "@/src/components/ui/data-table";
import { useEffect, useState } from "react";
import { Region } from "./model";
import { useSearch, usePageSize } from "./state";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/src/lib/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import { extractFromMultiName } from "./utils";

export function RegionsTable() {
  const [regions, setRegions] = useState<DataTableData<Region>>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 1 },
  });
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
  const search = useSearch();
  const pageSize = usePageSize();
  const { fetch } = useFetch();

  useEffect(() => {
    const fetchRegions = (page: number) =>
      fetch<DataTableData<Region>>(`/api/locations/regions?page=${page}&pageSize=${pageSize}&filter=${search}`);

    fetchRegions(page).then((data) => {
      setRegions(data);
    });
  }, [page, search, pageSize]);

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-md bg-white border">
        <DataTable
          columns={regionsColumns}
          pagination={regions}
          data={regions.data}
          onPageClick={setPage}
          onRowClick={(r) => navigate(`/locations/regions/${r.id}`)}
        />
      </div>
    </div>
  );
}

export const regionsColumns: ColumnDef<Region>[] = [
  {
    header: "Name",
    accessorFn: (r) => extractFromMultiName(r.names),
  },
  {
    header: "Country",
    accessorFn: (r) => extractFromMultiName(r.country.names),
  },
];
